export const environment = {
  production: false,
  oauthBaseUrl: 'https://dev-ottimizza-oauth-server.ottimizza.dev',
  oauthClientId: '858f84ff24730d133a63',
  serviceUrl: 'https://dev-integrador-contabil.ottimizza.dev',
  ticketsUrl: 'https://dev-api-chamados.ottimizza.dev',
  storageApplicationId: 'zap-contabil',
  storageBaseUrl: 'https://s1.ottimizza.com.br:55325',
  portalBaseUrl: 'https://dev-web-accounts.ottimizza.dev',
  supportUrl: 'https://suporte.ottimizza.com.br',
  imageCompressionBaseUrl: 'https://image-compression.ottimizza.com.br',
  firebase: {
    apiKey: 'AIzaSyBpjGFGALN75FQ_XUiv8OrSUnbh3P_e2QY',
    authDomain: 'integrador-ottimizza-3ba5f.firebaseapp.com',
    projectId: 'integrador-ottimizza-3ba5f',
    storageBucket: 'integrador-ottimizza-3ba5f.appspot.com',
    messagingSenderId: '747854823548',
    appId: '1:747854823548:web:bc6d3fe280da25b8c949f9',
    measurementId: 'G-MPF773VMXN',
  },
  theme: {
    primaryColor: '#004ecb',
    primaryAccent: 'palevioletred',
    dark: '#373435'
  },
  messagingBaseUrl: 'https://ws-notifications-service.herokuapp.com',
  oldMessagingBaseUrl: 'https://ottimizza-notification-service.herokuapp.com',
  headwayAccountId: '7qQeK7',
  urlSugestaoMelhorias: 'https://dev-web-sugestao.ottimizza.dev',
  urlDocumentationSugestoes: 'jacarandá',
  urlSalesforce: 'https://dev-api-salesforce-client.ottimizza.dev',
  featureToggleUrl: 'https://dev-api-tareffa-spring-full-ro.ottimizza.dev',
  ottimizzaStorageUrlAWS: 'https://dev-api-s3-storage.ottimizza.dev'
};
